import type { IUtaPolicy } from '../../types';
import { UtaPolicyAssessmentType } from '../../types';

export const getIsSpecialUtaPolicyTypeBenefit = (utaPolicyData: IUtaPolicy): boolean => {
  return utaPolicyData?.assessmentType === UtaPolicyAssessmentType.BENEFIT;
};
